import { useAppState } from "src/state";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";
import { SuperAdminTenantViewSchema } from "src/components/superadmin/tenants/SuperAdminTenantViewSchema";

export function SuperAdminTenantView() {

    const { currentItem } = useAppState().tenants;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={SuperAdminTenantViewSchema}
            data={currentItem}
            title="Tenant Overview"
            icon={Icons.tenants}
        />
    );
}
